"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPINNER_SIZES = void 0;
exports.SPINNER_SIZES = {
    m: 16,
    l: 24,
    xl: 32,
    xxl: 48,
    xxxl: 64,
};
//# sourceMappingURL=spinnerSizes.js.map